module.exports = __webpack_public_path__ + "static/media/cantos-arredondados.73f853a5.svg";